"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleNavigationMenu = toggleNavigationMenu;
exports.toggleNavigationMenuWidth = toggleNavigationMenuWidth;
exports.openNavigationMenu = openNavigationMenu;
exports.closeNavigationMenu = closeNavigationMenu;
exports.setConfirmedNavigation = setConfirmedNavigation;
exports.setLocation = setLocation;
exports.clearNavigation = clearNavigation;
var ActionTypes = require("../actionTypes/navigation");
function toggleNavigationMenu() {
    return {
        type: ActionTypes.TOGGLE_NAVIGATION_MENU
    };
}
function toggleNavigationMenuWidth() {
    return {
        type: ActionTypes.TOGGLE_NAVIGATION_MENU_WIDTH
    };
}
function openNavigationMenu() {
    return {
        type: ActionTypes.OPEN_NAVIGATION_MENU
    };
}
function closeNavigationMenu() {
    return {
        type: ActionTypes.CLOSE_NAVIGATION_MENU
    };
}
function setConfirmedNavigation(x) {
    return {
        type: ActionTypes.SET_CONFIRMED_NAVIGATION,
        payload: {
            x: x
        }
    };
}
function setLocation(location) {
    return {
        type: ActionTypes.SET_LOCATION,
        payload: {
            location: location
        }
    };
}
function clearNavigation() {
    return {
        type: ActionTypes.CLEAR_NAVIGATION
    };
}
